import React, { createContext, useContext, useState } from 'react';

const VoterAuthContext = createContext(null);

export function VoterAuthProvider({ children }) {
  const [voter, setVoter] = useState(() => {
    const stored = localStorage.getItem('voter_data');
    return stored ? JSON.parse(stored) : null;
  });

  const login = (token, voterData) => {
    localStorage.setItem('voter_token', token);
    localStorage.setItem('voter_data', JSON.stringify(voterData));
    setVoter(voterData);
  };

  const logout = () => {
    localStorage.removeItem('voter_token');
    localStorage.removeItem('voter_data');
    localStorage.removeItem('election_status');
    setVoter(null);
  };

  return (
    <VoterAuthContext.Provider value={{ voter, login, logout }}>
      {children}
    </VoterAuthContext.Provider>
  );
}

export function useVoterAuth() {
  return useContext(VoterAuthContext);
}
